<template>
  <div>
    <title>收付款账号管理</title>
    <section class="mainPart">
      <!--S 检索-->      
      <el-form inline :model="paymentForm">
        <el-form-item label="账号名称">
          <el-input clearable v-model="paymentForm.accountname" placeholder="请输入账号名称"></el-input>
        </el-form-item>
        <el-form-item label="开户银行">
          <el-input clearable v-model="paymentForm.openingbank" placeholder="请输入开户银行"></el-input>
        </el-form-item>
         <el-form-item label="状态" class="formTimeSlot">
            <el-select v-model="paymentForm.status"  placeholder="请选择" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="启用" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="reach">查询</el-button>
            <el-button type="primary" plain @click="openRdBox(2,'')">新增</el-button>
        </el-form-item>
      </el-form>
      <!--E 检索-->
      <!-- S 列表 -->
      <div class="gsListTable">
        <el-table class="comTable orderTable"  v-loading="loadingshow" ref="gsTable" :data="accountListData" border :maxHeight="tableHeight">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="账号名称" prop="accountname" sortable min-width="220">
            <template slot-scope="scope">
              <p :title="scope.row.accountname||''">{{scope.row.accountname||'--'}}</p>
              <small :title="scope.row.accountno||''">{{scope.row.accountno||'--'}}</small>
            </template>
          </el-table-column>
          <el-table-column label="开户银行" prop="openingbank" sortable min-width="220">
            <template slot-scope="scope">
              <span class="textHiden pdr70" :title="scope.row.openingbank||''">{{scope.row.openingbank||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属公司" prop="companyname" sortable min-width="220">
            <template slot-scope="scope">
              <span class="textHiden pdr70" :title="scope.row.companyname||'--'">{{scope.row.companyname||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" sortable prop="status" min-width="120">
            <template slot-scope="scope">
              <el-switch :value="scope.row.status?true:false" :width="45" class="isSwitch" :active-text="scope.row.status?'启':'禁'" @change="handleStatus(scope.row.status,scope.row.accountcode)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="memo" sortable min-width="250">
            <template slot-scope="scope">
              <span class="textFl" :title="scope.row.memo||''">{{scope.row.memo||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="90">
            <template slot-scope="scope">
              <p class="handle">
                <span title="详情" @click="openRdBox(0,scope.row)"><i class="icondetails"></i></span>
                <span title="编辑"  @click="openRdBox(1,scope.row)"><i class="iconedit"></i></span>
              </p>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="noData"><span>暂无数据</span></div>
          </template>
        </el-table>
      </div>
      <!-- E 列表 -->
      <!-- S 分页 -->
      <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam"></Page>
      <!-- E 分页 -->

      <!--S 新增/编辑/详情-->
      <el-dialog :visible.sync="accountMangeShow" :title="operateType == 0?'详情':operateType == 1?'编辑':'新增'" class="comDlog seniorMdg" :before-close="closeRdBox" append-to-body :close-on-click-modal="false">
        <el-form :model="accountForm" ref="formName" label-width="120px" class="comForm" :rules="accountRules" :disabled="operateType == 0">
          <el-row  class="goodsWrap">
            <el-col :span="12">
              <!-- <el-form-item label="归属门店" prop="store">
                <el-select v-model="accountForm.store" filterable placeholder="请选择或输入" clearable>
                  <el-option v-for="(item,index) in storeList" :key="index" :label="item.label" :value="item.value"></el-option>           
                </el-select>
              </el-form-item> -->
              <el-form-item label="账号名称" prop="accountname">
                <el-input v-model="accountForm.accountname"  maxlength="30" clearable></el-input>
              </el-form-item>
              <el-form-item label="账号" prop="account">
                <el-input v-model="accountForm.account" @blur="accountBlur" maxlength="20" clearable></el-input>
              </el-form-item>
              <el-form-item label="开户银行">
                <el-input v-model="accountForm.openingbank" maxlength="30" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属公司">
                <el-input v-model="accountForm.accountcpy" maxlength="30" clearable placeholder="请输入所属公司"></el-input>
              </el-form-item>
              <el-form-item label="状态">
                <el-switch v-model="accountForm.status" :width="45" class="isSwitch" :active-text="accountForm.status?'启':'禁'"></el-switch>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" v-model="accountForm.memo" clearable maxlength="50"  show-word-limit></el-input>
              </el-form-item> 
            </el-col>
          </el-row> 
        </el-form>
        <div v-if="operateType == 0" slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeRdBox(0)">关闭</el-button>
        </div>
        <div v-else slot="footer" class="dialog-footer">
          <el-button type="primary" :loading="loadings" @click="closeRdBox(1)">确定</el-button>
          <el-button @click="closeRdBox(0)">取消</el-button>
        </div>
      </el-dialog>
      <!--E 新增/编辑/详情-->

    </section>
  </div>
</template>
<script>
import Api from "@/apis/api";
import { Message, MessageBox } from "element-ui";
export default {
  name: 'ChannelList',
  data () {
    return {
      loadingshow:false,
      loadings:false,
      pageTotal:0, //总数
      currentPage:1, // 页数
      pageSize:30, // 条数
      //检索
      paymentForm: {
        accountname: "", //账号名称
        openingbank: "", //开户银行
        status:'',//状态
      },
      accountListData:[],
      tableHeight: window.innerHeight*.8, //表格动态高度
      accountMangeShow:false, //新增弹窗
      operateType:0, //操作类型
      accountForm:{
        accountcode:'',
        accountname:"",//账号名称
        account:"",//账号
        openingbank:"",//开户银行
        accountcpy:'',//所属公司
        status:true,//状态
        memo:'',//备注
      },
      accountRules:{
        accountname:[
          { required: true, message: '账号名称不能为空！', trigger: 'blur' }
        ],
        account:[
          { required: true, message: '账号不能为空！', trigger: 'blur' }
        ],
        // openingbank:[
        //   { required: true, message: '开户银行不能为空！', trigger: 'blur' }
        // ],
        // accountcpy:[
        //   { required: true, message: '所属公司不能为空！', trigger: 'blur' }
        // ],
      },
      storeList:[
        {label:'门店1',value:'0'},
        {label:'门店2',value:'1'},
        {label:'门店3',value:'2'}
      ],//门店列表
    }
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"],resolve),
  },
  methods: {
    accountBlur(){
      // let params ={
      //         accountcode:this.accountForm.accountcode,
      //         accountno:this.accountForm.account,//账号
      // }
      // Api.CHECKNAME(params).then(res =>{
      //     if(res.data.status!="200"){
      //        this.$message.error(res.data.message)
      //     }
      // })
    },
    //上下架常见问题
    handleStatus(status,accountcodes){
      if(status){
        MessageBox.confirm('确定要禁用该收款账号吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.updateStatus(0,accountcodes)
        }).catch(() => {
        });
      }else{
         this.updateStatus(1,accountcodes)
      }
    },
    updateStatus(status,accountcodes){
      Api.UODATESTATUS({status:status,accountcodes:accountcodes}).then(res =>{
          if(res.data.status=="200"){
            this.$message.success(res.data.message)
              this.getAccountinfoList();
          }else{
            this.$message.error(res.data.message)
          }
      })
    },
    //打开新增弹窗
    openRdBox(val,type){
      this.operateType = val;
      this.accountMangeShow = true;
      this.accountForm={
        accountcode:'',
        accountname:"",//账号名称
        account:"",//账号
        openingbank:"",//开户银行
        accountcpy:'',//所属公司
        status:true,//状态
        memo:'',//备注
      };
      this.loadings = false;
      if(val!=2){
          this.accountForm={
            accountcode:type.accountcode,
            accountname:type.accountname,//账号名称
            account:type.accountno,//账号
            openingbank:type.openingbank,//开户银行
            accountcpy:type.companyname,//所属公司
            status:type.status?true:false,//状态
            memo:type.memo,//备注
          }
      }else{
          setTimeout(()=>{
        this.$refs['formName'].resetFields();
      },300)
      }
    },
    //关闭新增弹窗
    closeRdBox(val){
      if(val==1){
        let params ={
              accountcode:this.accountForm.accountcode,
              accountname:this.accountForm.accountname,//账号名称
              accountno:this.accountForm.account,//账号
              openingbank:this.accountForm.openingbank,//开户银行
              companyname:this.accountForm.accountcpy,//所属公司
              status:Number(this.accountForm.status),//状态
              memo:this.accountForm.memo,//备注
        }
         this.loadings = true;
         this.$refs['formName'].validate((valid) => {
          if (valid) {
            let paras ={
              accountcode:this.accountForm.accountcode,
              accountno:this.accountForm.account,//账号
              }
              Api.CHECKNAME(paras).then(res =>{
                  if(res.data.status=="200"){
                     Api.SABEACCOUNTINFO(params).then(res =>{
                        if(res.data.status=="200"){
                            Message({
                              type: 'success',
                              message: res.data.message
                            });
                            this.loadings = false;
                            this.$refs['formName'].resetFields();
                            this.accountMangeShow = false;
                            this.getAccountinfoList();
                        }else{
                          this.loadings = false;
                            this.$message.error( res.data.message)
                        }
                    })
                  }else{
                    this.loadings = false;
                     this.$message.error(res.data.message)
                  }
              })
              
          } else {
            this.loadings = false;
            console.log('error submit!!');
            return false;
          }
        });
      }else{
          this.$refs['formName'].resetFields();
          this.accountMangeShow = false;
      }
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
      this.tableHeight = window.innerHeight - tbHeight - 130; 
    },
     // 分页
    nowPageParam(val,vals){
      this.pageSize = val;
      this.currentPage = vals;
      this.$refs.gsTable.bodyWrapper.scrollTop = 0;
      this.getAccountinfoList();
    },
    reach(){
      this.getAccountinfoList();
    },
    getAccountinfoList(){
       let param ={
              accountname:this.paymentForm.accountname,
              openingbank:this.paymentForm.openingbank,
              status:this.paymentForm.status!==''? Number(this.paymentForm.status):'',
              pageparam:{
                    pagesize: this.pageSize, //每页条数
                    currentpage: this.currentPage, //当前页数
                }
       }
       this.loadingshow = true;
       Api.GETACCOUNTINFOLIST(param).then(res =>{
         if(res.data.status=="200"){
            this.loadingshow = false;
            this.accountListData = res.data.data;
            this.pageTotal = res.data.pagebean.totalnum;
         }else{
            this.loadingshow = false;
            this.accountListData =[];
            this.pageTotal = 0;
         }
       })
    },
    
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted () {
    this.getAccountinfoList()
    //在dom渲染之后
    setTimeout(()=>{
      this.getHeight();
    },200)
  },
  destroyed(){ 
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
.pdr70{padding-right: 70px;width: auto;}
/*编辑新增查看*/
.editOdDlg >>> .el-dialog {width:1200px;} 
.editOdDlg >>> .el-dialog__body {max-height:550px;}

.goodsWrap >>> .el-form-item__content {width:65%; min-width: 200px; max-width: 340px;}
.goodsWrap >>> .el-form-item__content .el-select,.goodsWrap >>> .el-form-item__content .el-cascader,.goodsWrap >>> .el-date-editor--daterange.el-input__inner,.goodsWrap >>> .el-form-item__content .el-date-editor {width: 100%;}
.goodsWrap {width:100%;  -webkit-display: flex;display: flex; flex-wrap: wrap; flex-direction: row; align-items: flex-start;align-content: flex-end;}
</style>




// WEBPACK FOOTER //
// src/views/ManageFolder/ManageJsz/PaymentMange.vue